<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  @for (data of items; track data) {
    @if (data.type === 'link') {
      <div class="mt-3">
        <a
          [href]="data.value.url"
          target="_blank"
          class="no-underline block text-center p-[10px] border-2 border-solid mt-[5px] mb-[5px] rounded-md bg-transparent"
          [attr.style]="buildStyle('button', data.styles?.button)"
          >{{ data.value.label }}</a>
      </div>
    }
    @if (data.type === 'text') {
      <div>
        <p [attr.style]="buildStyle('text', data.styles?.text)" [innerHTML]="data.value.text | lineBreak">
        </p>
      </div>
    }
    @if (data.type === 'image') {
      <div>
        @if (data.value.url) {
          <img
            [src]="data.value.url"
            [alt]="data.value.altText"
            class="w-[100%]" />
        }
      </div>
    }
    @if (data.type === 'video') {
      <div class="text-center mt-1">
        <iframe width="100%" 
        height="250" referrerpolicy="strict-origin-when-cross-origin" [src]="getSafeUrl(data.value.url)" frameborder="0"></iframe>
      </div>
    }
    @if (data.type === 'location') {
      <div class="mt-3">
        @if (getLocationIframeUrl(data.value); as locationIframeUrl) {
          <iframe
            width="100%"
            height="220"
            style="border:0"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            [src]="locationIframeUrl"
          ></iframe>
        }
      </div>
    }
    @if (data.type === 'polygon') {
      <div class="mt-3">
        @if (mapsReady()) {
          <google-map
            height="220px"
            width="100%"
            [center]="getPolygonCenter(data.value)"
            [options]="polygonMapOptions"
            (mapInitialized)="fitPolygonToMap($event, data.value)"
          >
            @if (getPolygonPaths(data.value).length > 2) {
              <map-polygon
                [paths]="getPolygonPaths(data.value)"
                [options]="polygonOptions"
              ></map-polygon>
            }
          </google-map>
        }
      </div>
    }
  }
</div>
